import { inject, provideAppInitializer } from "@angular/core";
import { AuthService } from "./partials/services/auth.service";

export const appConfigInit = provideAppInitializer(() => {
  const initializerFn = ((authService: AuthService) => {
    return () => {
      return authService.checkSession();
    }
  })(inject(AuthService));
  return initializerFn();
});
